<template>
    <div class="view view-practice-results">
        <HeaderPracticeResults
            @closeResults="closeResults" />
        <ResultStatCorrectness :indicatorPercent="indicatorPercent"/>
        <Preloader
            v-if="show.preloader"
            preloaderText="Ortam hazırlanıyor." />
        <div
            v-if="!show.preloader"
            class="wr-result-stats">
            <ResultStatCorrect      :correctValue="correctValue"/>
            <ResultStatIncorrect    :incorrectValue="incorrectValue"/>
            <ResultStatSkipped      :skippedValue="skippedValue"/>
        </div>
        <Navbar
            @navlinkClick="navlinkClick" />
        <BtnPracticeRestart
            @click="$store.state.envDev ? practiceRestart() : practiceRestartApi()" />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import HeaderPracticeResults    from '@/components/HeaderPracticeResults.vue';
    import ResultStatCorrectness    from '@/components/ResultStatCorrectness.vue';
    import Preloader                from '@/components/Preloader.vue';
    import ResultStatCorrect        from '@/components/ResultStatCorrect.vue';
    import ResultStatIncorrect      from '@/components/ResultStatIncorrect.vue';
    import ResultStatSkipped        from '@/components/ResultStatSkipped.vue';
    import Navbar                   from '@/components/Navbar.vue';
    import BtnPracticeRestart       from '@/components/BtnPracticeRestart.vue';

    import FakeApi from '@/libs/FakeApi.js';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            HeaderPracticeResults,
            ResultStatCorrectness,
            Preloader,
            ResultStatCorrect,
            ResultStatIncorrect,
            ResultStatSkipped,
            Navbar,
            BtnPracticeRestart,
        },

        data(){
            return {
                allow: {
                    restart: true,
                },
                show: {
                    preloader: false,
                },
                abortController: null,
            };
        },

        computed: {
            indicatorPercent(){
                if(!this.$store.state.questionSet){
                    return 33;
                }

                let numQuestions = this.$store.state.questionSet.length;
                let numCorrect = this.$store.state.practiceStats.correct;
                return Math.floor((numCorrect / numQuestions) * 100);
            },

            correctValue(){
                return this.$store.state.practiceStats.correct;
            },

            incorrectValue(){
                return this.$store.state.practiceStats.incorrect;
            },
            
            skippedValue(){
                return this.$store.state.practiceStats.skipped;
            },
        },

        methods: {
            practiceRestart(){
                if(this.allow.restart == false){
                    return;
                }
                this.allow.restart  = false;
                this.show.preloader = true;

                let fakeApi = new FakeApi();
                let practiceOptions = {
                    practiceType: this.$store.state.input.initializePractice.practiceType,
                };

                fakeApi.initPractice(JSON.stringify(practiceOptions))
                .then(practiceData => {
                    this.$store.commit('setPracticeSession', practiceData.practiceSession);
                    this.$store.commit('setQuestionSet', practiceData.questionSet);

                    this.$store.commit('setRouterPracticeRestart', true);
                    this.$router.push(`/practice/${this.$store.state.input.initializePractice.practiceType}`);
                });
            },

            practiceRestartApi(){
                if(this.allow.restart == false){
                    return;
                }
                this.allow.restart  = false;
                this.show.preloader = true;

                let practiceOptions = {
                    practiceType: this.$store.state.input.initializePractice.practiceType,
                }
                let requestBody = "practiceOptions=" + JSON.stringify(practiceOptions);
                this.abortController = new AbortController();

                fetch(this.$store.state.api.initializePractice, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: requestBody,
                    signal: this.abortController.signal,
                })
                .then(async response => {
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(practiceData => {
                    this.$store.commit('setPracticeSession', practiceData.practiceSession);
                    this.$store.commit('setQuestionSet', practiceData.questionSet);

                    this.$store.commit('setRouterPracticeRestart', true);
                    this.$router.push(`/practice/${this.$store.state.input.initializePractice.practiceType}`);
                })
                .catch(err => {
                    console.error(err);
                    if(err == 'VIEW_PRACTICE_RESULTS/CLOSE_RESULTS::ABORT_REQUEST'){
                        return;
                    }
                    if(err == 'VIEW_PRACTICE_RESULTS/NAVLINK_CLICK::ABORT_REQUEST'){
                        return;
                    }
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    this.allow.restart  = true;
                    this.show.preloader = false;
                });
            },

            closeResults(){
                if(this.abortController){
                    this.abortController.abort("VIEW_PRACTICE_RESULTS/CLOSE_RESULTS::ABORT_REQUEST");
                }
            },

            navlinkClick(){
                if(this.abortController){
                    this.abortController.abort("VIEW_PRACTICE_RESULTS/NAVLINK_CLICK::ABORT_REQUEST");
                }
            },
        },

        mounted(){
            this.$store.state.sfx.complete.currentTime = 0;
            this.$store.state.sfx.complete.play();
        }
    };
</script>

<style scoped src="@/css/views/view-practice-results.css"></style>